import React, { Component } from 'react';
import { Button, Spin, Table, notification, Col, Row, Modal, message, Icon } from 'antd';
import moment from 'moment';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';

class ViewStudentInterviewTimeData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            postList: [],
            Data: [],
            selectedpost: null,
            loading: false,
            totalCount: 0,
            showDeleteConfirm: false,
        };
    }

    componentDidMount() {
        this.fetchposts();
    }

    // Converts an array into objects with Id and Name keys for dropdown options.
    transformArray = (responseArray) => {
        return responseArray.map((item) => ({
            Id: item,
            Name: item,
        }));
    };

    // Fetch centers when the page loads
    fetchposts = async () => {
        this.setState({ loading: true, postList: [], Data: [], selectedpost: null });
        try {
            const response = await _AdminService.GetDistinctPostFromStudentInterviewTimeData();   // Assuming API returns data in response.data
            this.setState({ postList: this.transformArray(response.data), loading: false });
        } catch (error) {
            this.setState({ loading: false });
            // notification.error({ message: 'Error fetching centers', description: error.message });
        }
    };

    // handlePostChange = async (event) => {
    //     const selectedpost = event.target.value;

    //     if(selectedpost === "Select Post" || selectedpost === " "){
    //         this.setState({selectedpost,Data:[],loading:false});
    //         return;
    //     }

    //     this.setState({ selectedpost, loading: true });
    //     try {

    //         const response = await _AdminService.GetAllStudentInterviewTimeDataByPost(event.target.value);

    //         if (response.data) {
    //             this.setState({ Data: response.data, loading: false });
    //         }

    //     } catch (error) {
    //         this.setState({ loading: false });
    //         //notification.error({ message: 'Error fetching Data', description: error.message });
    //     }
    // };


    handlePostChange = async (event) => {
        const selectedPost = event.target.value;

        // Check if the selected value is "Select Post" (or empty string), clear data if true
        if (selectedPost === "Select Post" || selectedPost.trim() === "") {
            this.setState({ selectedPost, Data: [], totalCount: 0, loading: false });
            return;
        }

        // Proceed with fetching data if a valid post is selected
        this.setState({ selectedPost, loading: true });
        try {
            const response = await _AdminService.GetAllStudentInterviewTimeDataByPost(event.target.value);

            // If the response contains data, update the state with it
            if (response.data) {
                this.setState({ Data: response.data, totalCount: response.data.length, loading: false });
            }

        } catch (error) {
            this.setState({ loading: false });
            // notification.error({ message: 'Error fetching Data', description: error.message });
        }
    };


    onViewClick = async (record) => {
        try {
            this.setState({ isLoading: true });

            const response = await _AdminService.GetStudentDataForAttendance(record.StartRoleNumber, record.EndRoleNumber);
            console.log(response);

            const candidates = response.data.Obj;

            if (candidates && candidates.length > 0) {

                const updatedCandidates = candidates.map((candidate) => ({
                    ...candidate,
                    candidateSignature: "",  // Initial empty signature
                    candidateName: `${candidate.Firstname || ''} ${candidate.MiddleName || ''} ${candidate.LastName || ''}`.trim(),
                }));

                this.setState({
                    isLoading: false,
                });
            }
        } catch (e) {
            console.error("Error:", e);
            this.setState({ isLoading: false });
            notification.error({
                message: 'Error',
                description: 'There was an error fetching the candidate data.',
            });
        }
    };

    deleteStudentInterviewTimeData = async () => {
        this.setState({ loading: true });
        try {
            const response = await _AdminService.DeleteStudentInterviewTimeData();
            if (response.data.IsSuccess) {
                this.setState({
                    postList: [],
                    Data: [],
                    selectedpost: null,
                    loading: false,
                });

            } else {
                this.setState({ loading: false });
                message.error("Failed to delete student interview time data.");
            }
        } catch (error) {
            this.setState({ loading: false });
            message.error("Failed to delete student interview time data.");
            console.error('Error deleting student interview time data:', error);
        }
    };

    handleDeleteConfirmation = () => {
        this.setState({ showDeleteConfirm: true });
    };


    render() {
        const { postList, Data, loading } = this.state;

        const TableColumns = [
            // {
            //   title: 'ID',
            //   dataIndex: 'Id',
            //   key: 'Id',
            //   width: '4%',
            //   sorter: (a, b) => a.Id - b.Id,
            // },
            {
                title: 'Role Number',
                dataIndex: 'RoleNumber',
                key: 'RoleNumber',
                width: '6%',
                sorter: (a, b) => a.RoleNumber - b.RoleNumber,
            },
            {
                title: 'Interview Date',
                dataIndex: 'InterviewDate',
                key: 'InterviewDate',
                width: '10%',
                render: (text, record) =>
                    moment(record.InterviewDate).isValid()
                        ? moment(record.InterviewDate).format('DD-MMM-YYYY')
                        : '',
                sorter: (a, b) => moment(a.InterviewDate).unix() - moment(b.InterviewDate).unix(),
            },
            {
                title: 'Interview Time',
                dataIndex: 'InterviewTime',
                key: 'InterviewTime',
                width: '8%',
                sorter: (a, b) => a.InterviewTime.localeCompare(b.InterviewTime),
            },
            {
                title: 'Post',
                dataIndex: 'Post',
                key: 'Post',
                width: '8%',
                filterSearch: true,
                sorter: (a, b) => a.Post.localeCompare(b.Post),
            },
            {
                title: 'Post ID',
                dataIndex: 'PostId',
                key: 'PostId',
                width: '6%',
                sorter: (a, b) => a.PostId - b.PostId,
            },
        ];

        return (
            <Spin spinning={loading}>

                <div className="container-fluid p-3">
                    <PageHeader
                        title="View Candidate Interview Time Data"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Candidates' }, { label: 'View Candidate Interview Time Data' }]}
                    />
                    <div className="ent-panel mb-3">
                        <Row gutter={16} className="m-0 d-flex align-items-center">
                            <Col span={4} className="d-flex align-items-center">
                                <label htmlFor="center" className="mb-0 mr-2">Post:</label>
                                <DropdownList
                                    wrapClass="w-100 mb-0"
                                    id="Post"
                                    placeholder="Select Post"
                                    options={postList}
                                    onChange={this.handlePostChange}
                                    value={this.state.selectedpost}
                                    name="Post"
                                />
                            </Col>

                            <Col span={6} style={{ marginLeft: "25px", fontWeight: "bold" }}>
                                Total Records : {this.state.totalCount}
                            </Col>

                            <Col span={13} className="d-flex align-items-center justify-content-end pr-0">
                                <a
                                    type="primary"
                                    danger
                                    className="button-global button-border removebutton addbutton autoWidth d-inline-block text-center autoHeight"
                                    onClick={this.handleDeleteConfirmation}
                                >   <Icon type="delete" className="mr-2 align-middle mb-1" />
                                    Delete Candidate Interview Time Data
                                </a>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Table
                                size="small"
                                columns={TableColumns}
                                dataSource={this.state.Data}  // Ensure the data is passed as the correct format
                                rowKey="Id"
                                pagination={false}
                                className="table-striped-rows admin-table"
                            />
                        </div>
                    </div>
                </div>
                <Modal
                    footer={false}
                    onCancel={() => this.setState({ showDeleteConfirm: false })}
                    visible={this.state.showDeleteConfirm}
                    className="modelPopAnt admin-home"
                >
                    <ConfirmPopup
                        message="Are you sure? Do you want to delete the student interview time data?"
                        onCancel={() => {
                            console.log("Operation canceled.");
                            this.setState({ showDeleteConfirm: false });
                        }}
                        onOk={() => {
                            this.setState({ showDeleteConfirm: false });
                            return new Promise((resolve, reject) => {
                                this.deleteStudentInterviewTimeData()
                                    .then(() => {
                                        message.success("Candidate interview time data deleted successfully!");
                                        resolve();
                                    })
                                    .catch((error) => {
                                        message.error("Failed to delete student interview time data.");
                                        console.error("Failed to delete student interview time data:", error);
                                        reject();
                                    });
                            });
                        }}
                    />
                </Modal>
            </Spin>
        );
    }
}

export default ViewStudentInterviewTimeData;


